import { InjectionToken } from '@angular/core';

export interface SpriteConfig {
  asyncSprite: () => Promise<string>;
}

export const SPRITE_CONFIG_TOKEN = new InjectionToken('spriteConfig');
